import React, { useEffect } from 'react';

import { JiraSoftwareBoardAri } from '@atlassian/ari/jira-software/board';
import { useBoardId } from '@atlassian/jira-board-settings-common/src/common/utils/use-board-id';
import { useEntryPoint } from '@atlassian/jira-entry-point';
import { JiraEntryPointContainer } from '@atlassian/jira-entry-point-container';
import { BoardSettingsCardColorsSkeleton } from '@atlassian/jira-skeletons';
import { useCloudId } from '@atlassian/jira-tenant-context-controller';

import { cardColorsSettingPageEntryPoint } from './entrypoint';

export const CardColorsSettingsPage = () => {
	const boardId = useBoardId();
	const cloudId = useCloudId();

	const boardAri = JiraSoftwareBoardAri.create({
		siteId: cloudId,
		boardId: String(boardId),
	}).toString();

	const { entryPointActions, entryPointReferenceSubject } = useEntryPoint(
		cardColorsSettingPageEntryPoint,
		{ boardId: boardAri },
	);

	useEffect(() => {
		entryPointActions.load();
		return () => {
			entryPointActions.unload();
		};
	}, [entryPointActions]);

	return (
		<JiraEntryPointContainer
			id="jira-card-colors-setting-page"
			packageName="cardColorsSettings"
			entryPointReferenceSubject={entryPointReferenceSubject}
			runtimeProps={{}}
			fallback={<BoardSettingsCardColorsSkeleton />}
		/>
	);
};
